import { render, staticRenderFns } from "./resale.vue?vue&type=template&id=2630b939&"
import script from "./resale.vue?vue&type=script&lang=js&"
export * from "./resale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports